export default __webpack_public_path__ + "static/Vidrios_Aluminios_2-fd4bc3658504c8d42c8cdd90513188bf.png";